import React from 'react';
import "./companiesData.css";

const CompaniesData = (props) => {
    const companiesData = props.companiesList.map(company=> (
        <>
            <tr key={company.id}>
                    <td>
                        {company.name}
                    </td>
                    <td>
                        {company.templateID}
                    </td>
                    <td>
                        {company.folderID}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={company.id} onClick={props.handleDeleteCompany}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    return ( 
        <>
            <div className="tableRow">
                <table className="companiesTable">
                    <tbody>
                        <tr>
                            <th>Nazwa</th>
                            <th>ID szablonu analizy</th>
                            <th>ID folderu</th>
                            <th>Akcja</th>
                        </tr>
                        {companiesData}
                    </tbody>
                </table> 
            </div>  
        </>
    );
}
 
export default CompaniesData;